import { MapPin } from "lucide-react";
import { Reveal, Chapter } from "./shared";

const TOWNS = [
  "West Chester",
  "Kennett Square",
  "Downingtown",
  "Coatesville",
  "Exton",
  "Oxford",
  "Malvern",
  "Phoenixville",
];

const WhyLocal = () => (
  <section className="py-16 sm:py-24 lg:py-28">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
      <div className="flex flex-col gap-5">
        <Chapter num="04" label="Why Local" />
        <Reveal delay={0.1}>
          <h2 className="text-3xl sm:text-4xl font-serif font-normal tracking-tight text-[#16324a] leading-tight">
            We Live Here. <em className="text-[#c99a43]">We Shop Here.</em>
          </h2>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="text-base sm:text-lg text-[#334e68] leading-relaxed">
            We know Chester County customers because we are Chester County customers. That means
            we build sites and profiles that speak the way your actual customers search and talk —
            not generic copy from an agency three states away.
          </p>
        </Reveal>
      </div>

      <Reveal delay={0.15}>
        <div className="bg-white border border-[#e7e1d6] rounded-2xl p-7 sm:p-9">
          <span className="inline-flex items-center gap-2 text-[13px] font-bold tracking-[0.14em] uppercase text-[#627d98]">
            <MapPin size={15} className="text-[#c99a43]" /> Proudly Serving
          </span>
          <div className="mt-5 flex flex-wrap gap-2.5">
            {TOWNS.map((town) => (
              <span
                key={town}
                data-testid={`town-chip-${town.toLowerCase().replace(/\s+/g, "-")}`}
                className="px-4 py-2 rounded-full border border-[#e7e1d6] bg-[#faf7f2] text-sm font-medium text-[#334e68] hover:border-[#c99a43] hover:text-[#a37d3f] transition-colors duration-300"
              >
                {town}
              </span>
            ))}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default WhyLocal;
